import { getLang } from "@/i18n/helpers"

export const authRedirectRoutes = [
    {
        path: '/auth',
        children: [
            {
                path: '',
                redirect: (to) => {
                    const locale = to.params.locale || getLang(navigator.language)
                    return {
                    path: `/${locale}/login`,
                    query: to.query
                    }
                }
            },
            {
                path: 'errors',
                redirect: (to) => {
                    const locale = to.params.locale || getLang(navigator.language)
                    return {
                    path: `/${locale}/errors`,
                    query: to.query
                    }
                }
            },
            {
                path: 'login',
                redirect: (to) => {
                    const locale = to.params.locale || getLang(navigator.language)
                    return {
                    path: `/${locale}/login`,
                    query: to.query
                    }
                }
            },
            {
                path: 'register',
                redirect: (to) => {
                    const locale = to.params.locale || getLang(navigator.language)
                    return {
                    path: `/${locale}/register`,
                    query: to.query
                    }
                }
            },
            {
                path: 'recovery',
                redirect: (to) => {
                    const locale = to.params.locale || getLang(navigator.language)
                    return {
                    path: `/${locale}/recovery`,
                    query: to.query
                    }
                }
            },
            {
                path: 'verification',
                redirect: (to) => {
                    const locale = to.params.locale || getLang(navigator.language)
                    return {
                    path: `/${locale}/verification`,
                    query: to.query
                    }
                }
            }
        ]
    }
]

export const authLocaleRoutes = [
    {
        path: 'login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '@/features/auth/views/Login.vue'),
    },
    {
        path: 'register',
        name: 'Register',
        component: () => import(/* webpackChunkName: "register" */ '@/features/auth/views/Register.vue'),
    },
    {
        path: 'recovery',
        name: 'Recovery',
        component: () => import(/* webpackChunkName: "recovery" */ '@/features/auth/views/Recovery.vue'),
    },
    {
        path: 'verification',
        name: 'Verification',
        component: () => import(/* webpackChunkName: "verification" */ '@/features/auth/views/Verification.vue'),
    }
]
